var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingVsInscanOutscanReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1600_20217)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1600_20217)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1600_20217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 0H9.2C4.11898 0 0 4.11898 0 9.2V70C0 75.081 4.11898 79.2 9.2 79.2H70C75.081 79.2 79.2 75.081 79.2 70V9.2C79.2 4.11898 75.081 0 70 0Z",
    fill: "#F8FBFF",
    stroke: "#F0F2F5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7337 17.1914H24C21.2386 17.1914 19 19.43 19 22.1914V64.9042C19 67.6656 21.2386 69.9042 24 69.9042H50.7337C53.4951 69.9042 55.7337 67.6656 55.7337 64.9042V22.1914C55.7337 19.43 53.4951 17.1914 50.7337 17.1914Z",
    fill: "#6EBEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 20.2153L54.4833 20.2148L55.1903 69.2489L20.25 68.6309V20.2153Z",
    fill: "#9DB8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4833 20.2148H20.25V68.6305H54.4833V20.2148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.669 20.2153L44.3171 20.2148L44.1911 21.6874H30.543L30.669 20.2153Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.896 18.1081H35.5735V17.1934H39.5783V18.1081H43.2558C43.8854 18.1081 44.4539 18.6255 44.4002 19.2525L44.3176 20.2159L30.6694 20.2163L30.752 19.2529C30.8058 18.6246 31.2664 18.1077 31.896 18.1081Z",
    fill: "#9DB8CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.687 17.8457H35.3649V12.0024C35.3649 10.901 36.2659 10 37.3673 10C38.4687 10 39.3697 10.901 39.3697 12.0024V17.8457H43.0472C43.6768 17.8457 44.1916 18.3605 44.1916 18.9901V21.6871H30.5435V18.9901C30.543 18.3605 31.0578 17.8457 31.687 17.8457ZM37.3669 11.082C36.8586 11.082 36.4465 11.4941 36.4465 12.0024C36.4465 12.5107 36.8586 12.9223 37.3669 12.9223C37.8752 12.9223 38.2868 12.5103 38.2868 12.0019C38.2872 11.494 37.8752 11.082 37.3669 11.082Z",
    fill: "#314252",
    stroke: "#314252",
    strokeWidth: 0.216,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5085 25.5586H27.4434V30.2764H47.5085V25.5586Z",
    fill: "#E46A5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8395 32.1328H23.1128V34.4917H51.8395V32.1328Z",
    fill: "#F9AA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8395 36.1387H23.1128V38.4976H51.8395V36.1387Z",
    fill: "#F9AA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8395 40.1406H23.1128V42.4996H51.8395V40.1406Z",
    fill: "#F9AA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8395 44.1445H23.1128V46.5035H51.8395V44.1445Z",
    fill: "#F9AA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3206 48.291H23.1128V54.4685H36.3206V48.291Z",
    fill: "#6EBEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8396 48.291H38.6318V54.4685H51.8396V48.291Z",
    fill: "#6EBEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3206 56.0391H23.1128V58.398H36.3206V56.0391Z",
    fill: "#F9AA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3206 59.6562H23.1128V62.0152H36.3206V59.6562Z",
    fill: "#F9AA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3206 63.2734H23.1128V65.6323H36.3206V63.2734Z",
    fill: "#F9AA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8396 56.0391H38.6318V58.398H51.8396V56.0391Z",
    fill: "#F9AA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8396 59.6562H38.6318V62.0152H51.8396V59.6562Z",
    fill: "#F9AA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8396 63.2734H38.6318V65.6323H51.8396V63.2734Z",
    fill: "#F9AA45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6408 34.9921L59.9996 32.6543L59.459 36.7107L43.5573 62.7886C43.2997 63.2114 42.7428 63.3464 42.32 63.0888L41.0388 62.3078C40.6161 62.0502 40.481 61.4933 40.7386 61.0705L56.6408 34.9921Z",
    fill: "#314252"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6406 34.9921L59.9995 32.6543L59.4589 36.7107L44.2474 61.6567C43.152 61.2206 42.2235 60.6439 41.4292 59.9381L56.6406 34.9921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6411 34.9921L59.9999 32.6543L59.4593 36.7107L44.7958 60.7578C43.6879 60.3295 42.7598 59.7528 41.9775 59.0393L56.6411 34.9921Z",
    fill: "#E46A5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6411 34.9921L59.9999 32.6543L59.4593 36.7107C58.9609 36.5206 58.4612 36.2772 57.9722 35.9791C57.4836 35.6811 57.0381 35.3482 56.6411 34.9921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8901 33.4267L59.9997 32.6543L59.8212 33.9944C59.6565 33.9316 59.4914 33.8512 59.3301 33.7527C59.1684 33.6542 59.0213 33.5441 58.8901 33.4267Z",
    fill: "#666666"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1600_20217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1600_20217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1600_20217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingVsInscanOutscanReport);
export default __webpack_public_path__ + "static/media/bookingVsInscanOutscanReport.0a919efeca856f4e9f5bc5798dc889e9.svg";
export { ForwardRef as ReactComponent };